<template>
  <div class="intro-y col-span-12 overflow-auto lg:overflow-visible">
    <div id="ques-add-modal" class="p-5 float-right">
      <div class="preview">
        <div class="text-center">
          <!--          data-toggle="modal"
          data-target="#ques-add"-->
          <a
            class="button inline-block bg-theme-1 text-white"
            @click="openAddQues"
            >+ Add Question</a
          >
        </div>
      </div>
    </div>

    <h2 class="text-lg font-medium truncate mr-5">
      QUESTIONS: {{ ques.length }}, TOTAL SCORE:
      {{ ques.reduce((a, b) => a + b.score, 0) }}
    </h2>
    <div class="text-lg font-medium">
      <a
        :href="`https://quiz.upskill.com.bd/quiz/${quiz.quiz_id}?public=true`"
        target="_blank"
        class="text-blue-500 hover:text-blue-700"
        >Preview (Do not share)</a
      ><br />
      <a
        :href="`https://quiz.upskill.com.bd/quiz/${quiz.quiz_id}`"
        target="_blank"
        class="text-blue-500 hover:text-blue-700"
        >Quiz Link</a
      >
    </div>
    <!-- Added the job Assessment Option -->
    <div class="my-4">
      <h2 class="text-lg font-medium truncate mr-5">
        Job name (Required) No spaces allowed
      </h2>
      <input
        v-model="jobName"
        type="text"
        class="input w-full border"
        placeholder="job Name this compulsory field"
      />
      <br />
      <br />
      <a @click="addJobName()" class="button inline-block bg-theme-1 text-white"
        >Add job Name</a
      >
      <div class="outputCustom"></div>
    </div>

    <table class="table table-report -mt-2">
      <thead>
        <tr>
          <th
            v-for="h in headers"
            :key="h"
            class="text-center whitespace-no-wrap"
          >
            {{ h }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(q, i) in ques" :key="q.question_id" class="intro-x">
          <td>
            <div class="font-medium ">
              {{ i + 1 }}# {{ q.question_description }}
            </div>
            <div class="text-gray-600 text-xs ">
              {{ q.options.length > 0 ? q.options.join(', ') : '' }}
            </div>
          </td>
          <td>
            <div class="text-center">
              {{ q.answer }}
            </div>
          </td>
          <td class="text-center">{{ q.question_type }}</td>
          <td class="text-center">
            <div>
              {{ q.score }}
            </div>
          </td>
          <td class="table-report__action ">
            <div class="flex justify-center items-center">
              <!--              data-toggle="modal"-->
              <!--              data-target="#ques-add"-->
              <a
                class="flex items-center mr-3 cursor-pointer"
                @click="openEditQues(q)"
              >
                <CheckSquareIcon class="w-4 h-4 mr-1" />
                Edit
              </a>
              <a
                class="flex items-center text-theme-6 cursor-pointer"
                data-toggle="modal"
                data-target="#delete-confirmation-modal"
                @click="deleteQuestion(q)"
              >
                <Trash2Icon class="w-4 h-4 mr-1" /> Delete
              </a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs'
import Uploader from './Uploader'
//import Button from "../../views/Button";
export default {
  name: 'UTableVue',
  components: {
    // Button,
    Uploader,
  },
  props: ['ques', 'quiz'],
  data() {
    return {
      headers: ['Question', 'Answer', 'Type', 'Score', 'Actions'],
      correctAnswer: {},
      images: {},
      model: {
        question_subject: '',
        question_description: '',
        question_type: 'MCQ',
        options: [],
        answer_type: 'predefined',
        answer: '',
        score: 1,
        Other: {},
      },
      jobName: '',
      isEditMode: false,
      imageChanged: false,
      imageOption: {},
    }
  },
  methods: {
    addJobName() {
      var text = `https://quiz.upskill.com.bd/assessment/${this.quiz.quiz_id}?public=true&job=${this.jobName}`
      navigator.clipboard.writeText(text).then(
        function() {
          document.getElementsByClassName('outputCustom').innerHtml = text
          window.alert('Async: Copying to clipboard was successful!')
        },
        function(err) {
          console.error('Async: Could not copy text: ', err)
        }
      )
    },
    deleteQuestion(q) {
      this.$dialog
        .confirm('Are you sure, you want to delete the question?')
        .then(() => {
          this.$upskill.orgDeleteQuesByID(q.question_id).then(() => {
            this.$emit('quesAdded')
          })
        })
        .catch(() => {})
    },
    openAddQues() {
      this.model = {}
      this.images = {}
      this.isEditMode = false
      this.$emit('add')
    },
    openEditQues(q) {
      this.images = {}
      this.model = q
      this.images = q.Other['images'] ? q.Other.images : {}
      this.isEditMode = true
      this.$emit('edit', { questions: q, images: this.images })
    },
    uploadedFile(e, opt) {
      let link =
        'https://upskill-files.s3-ap-southeast-1.amazonaws.com/' + e.link
      // console.log(link);
      // console.log(typeof opt, opt);
      let img = {
        [opt]: link,
      }
      this.images = { ...this.images, ...img }
      // if (!this.model.Other["images"]) {
      //   this.model.Other.images = {};
      // }
      // this.model.Other.images[o] = {
      //   imageURL: link,
      //   label: "",
      //   view_mode: "full"
      // };
      // this.images[String(o)] = {
      //   imageURL: link,
      //   label: "",
      //   view_mode: "full"
      // };
      this.imageChanged = !this.imageChanged
    },
    findImage(o) {
      // if (!Object.keys(this.model.Other).includes("images")) {
      //   return "";
      // }
      // if (!Object.keys(this.model.Other.images).includes(o)) {
      //   return "";
      // }
      // return this.model.Other.images[o].imageURL;
      if (!this.images[o]) {
        return ''
      }
      return this.images[o]
    },
    updateQues() {
      this.model.answer = this.selectedAnswer()
      this.model.question_subject = this.quiz.quiz_subject
      this.model.answer_type = 'predefined'
      this.model.question_type = 'MCQ'
      this.model.score = parseInt(this.model.score)
      this.model.other = {} //NEED WORK
      this.model.other.images = this.images //NEED WORK
      this.$upskill.orgUpdateQues(this.model).then(() => {
        this.closeAllModals()
        this.resetModel()
        window.alert('updated!')
      })
    },
    resetModel() {
      this.model = {
        question_subject: '',
        question_description: '',
        question_type: 'MCQ',
        options: [],
        answer_type: 'predefined',
        answer: '',
        score: 1,
        Other: {},
      }
    },
    changedType(e) {
      switch (e) {
        case 'MCQ':
          this.model.options = []
          this.model.question_type = 'MCQ'
          this.model.answer = ''
          this.model.answer_type = 'predefined'
          break
        case 'textarea':
          this.model.options = []
          this.model.question_type = 'textarea'
          this.model.answer = ''
          this.model.answer_type = 'manual'
          break
        case 'textbox':
          this.model.options = []
          this.model.question_type = 'textbox'
          this.model.answer = ''
          this.model.answer_type = 'manual'
          break
        case 'file':
          this.model.options = []
          this.model.question_type = 'file'
          this.model.answer = ''
          this.model.answer_type = 'manual'
          break
        default:
          this.model.options = []
          this.model.question_type = 'MCQ'
          this.model.answer = ''
          this.model.answer_type = 'predefined'
      }
    },
    addQuestion() {
      this.isEditMode = false
      this.model.answer = this.selectedAnswer()
      this.model.question_subject = this.quiz.quiz_subject
      // this.model.answer_type = "predefined";
      // this.model.question_type = "MCQ";
      this.model.other = {} //NEED WORK
      this.model.other.images = this.images //NEED WORK
      this.model.score = parseInt(this.model.score)
      this.$upskill.orgAddQues(this.model).then((res) => {
        let ques_id = res.data.data.question_id
        let bindForm = {
          quiz_id: this.quiz.quiz_id,
          question_ids: [ques_id],
        }
        this.$upskill.orgSaveQuesToQuiz(bindForm).then(() => {
          this.model = {
            question_id: '',
            question_subject: '',
            question_description: '',
            question_type: 'MCQ',
            options: [],
            answer_type: 'predefined',
            answer: '',
            score: 1,
            Other: {},
          }
          this.correctAnswer = {}
          this.closeAllModals()
          this.resetModel()
          this.$emit('quesAdded')
        })
      })
    },
    selectedAnswer() {
      for (let k in this.correctAnswer) {
        if (this.correctAnswer[k]) {
          return k
        }
      }
      return ''
    },
    closeAllModals() {
      const modals = document.getElementsByClassName('modal')
      for (let i = 0; i < modals.length; i++) {
        modals[i].classList.remove('show')
      }
    },
    changedAns(o) {
      for (let k in this.correctAnswer) {
        this.correctAnswer[k] = false
      }
      this.correctAnswer[o] = true
    },
  },
}
</script>

<style scoped></style>
